import router from '@/router'
export default {
  LOGIN(state, { token }) {
    localStorage.setItem('token', token)
    state.token = token
  },
  LOGOUT(state) {
    state.user = null
    // state.hasToken = state.isOpen = false
    state.isOpen = false
    localStorage.clear()
    sessionStorage.clear()
    // state.fromSchool = false
    if (state.isWeixin) {
      window.wxAuth()
    } else {
      router.push({ name: 'login' })
    }
  },
  SET_USER(state, data) {
    state.user = state.user || {}
    state.user = { ...state.user, ...data }
  },
  HAS_PARENT_PHONE(state, boolean) {
    state.hasParentPhone = boolean
  },
  // HAS_TOKEN(state, boolean) {
  //   state.hasToken = boolean
  // },
  IS_OPEN(state, boolean) {
    state.isOpen = boolean
  },
  CLASSINFO(state, data = []) {
    state.classData = data.map((v, k) => {
      v.id = k
      return v
    })
  },
  SETVIEWERURL(state, url) {
    sessionStorage.setItem('currPDF', url)
    state.viewerUrl = url
  },
  SET_FROM_SCHOOL(state, boolean) {
    state.fromSchool = boolean
  }
}
